<template>
    <div></div> <!-- Opcionalmente, pode mostrar um spinner ou mensagem -->
  </template>
  
  <script>
  export default {
    name: 'logout',
    created() {
      this.performLogout();
    },
    methods: {
      performLogout() {
        // Aqui você coloca a lógica de logout
        // Por exemplo, se estiver usando um plugin de autenticação:
        this.$auth.logout().then(() => {
          // Após logout, redireciona para a página de login
          this.$router.push('/login');
        }).catch((error) => {
          console.error('Erro ao fazer logout:', error);
          // Opcional: redirecionar mesmo em caso de erro
          this.$router.push('/login');
        });
        
        // Se não estiver usando um plugin, você pode fazer:
        /*
        // Limpar tokens ou dados de autenticação
        localStorage.removeItem('authToken');
        // Redirecionar para a página de login
        this.$router.push('/login');
        */
      }
    }
  }
  </script>